import React, { forwardRef } from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FACET_PARTICLE_CLIP_PATHS } from 'Views/Onboarding/consts';

const styles = (theme) => ({
  root: {
    width: 150,
    height: 150,
    background: theme.palette.facet.accentBlue20,
    clipPath: FACET_PARTICLE_CLIP_PATHS.lessRounded,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    fontSize: '3em',
    color: '#0082b7', // <--- Do we really want to add another accentBlue??
  },
});

const FacetParticleIcon = forwardRef(({
  classes,
  style, // Needed for transitions to work
  className,
  icon,
}, ref) => {
  const Icon = icon;

  return (
    <div className={classNames(classes.root, className)} ref={ref} style={style}>
      <Icon
        color={'primary'}
        fontSize={'large'}
        className={classes.icon}
      />
    </div>
  );
});

FacetParticleIcon.defaultProps = {
  className: '',
};

FacetParticleIcon.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  icon: PropTypes.node.isRequired,
  style: PropTypes.object,
};

export default withStyles(styles)(FacetParticleIcon);
